<app-auth-card
  [message]="'Redirecionando...'"
  [loadingVisibility]="true"
  [buttonAcessarVisibility]="false"
></app-auth-card>

